"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = DribbbleSquare;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function DribbbleSquare(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("style", {
    dangerouslySetInnerHTML: {
      __html: ".cls-1{fill:#010101;}"
    }
  })), /*#__PURE__*/_react["default"].createElement("title", null, "Dribbble"), /*#__PURE__*/_react["default"].createElement("g", {
    id: "Social_media",
    "data-name": "Social media"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "dribbble-square"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "outline-4",
    "data-name": "outline"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-1",
    d: "M81.429,7.5H18.571A11.084,11.084,0,0,0,7.5,18.571V81.429A11.084,11.084,0,0,0,18.571,92.5H81.429A11.084,11.084,0,0,0,92.5,81.429V18.571A11.084,11.084,0,0,0,81.429,7.5ZM87.5,81.429A6.079,6.079,0,0,1,81.429,87.5H18.571A6.079,6.079,0,0,1,12.5,81.429V18.571A6.079,6.079,0,0,1,18.571,12.5H81.429A6.079,6.079,0,0,1,87.5,18.571Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-1",
    d: "M50,29A21,21,0,1,0,71,50,21.024,21.024,0,0,0,50,29Zm11.891,7.61c-.323.46-3.023,4.089-9.4,6.479a96,96,0,0,0-6.693-10.5A17.891,17.891,0,0,1,61.891,36.61ZM42.374,33.794a114.578,114.578,0,0,1,6.65,10.374,66.953,66.953,0,0,1-16.582,2.186A18,18,0,0,1,42.374,33.794ZM32.063,50.027c0-.183,0-.366.009-.548a66.192,66.192,0,0,0,18.435-2.552c.513,1.005,1,2.025,1.454,3.044-6.486,1.827-12.379,7.072-15.287,12.05A17.866,17.866,0,0,1,32.063,50.027ZM38.99,64.178c1.874-3.83,6.959-8.774,14.19-11.241a74.619,74.619,0,0,1,3.827,13.6A17.9,17.9,0,0,1,38.99,64.178Zm21.032.719a77.416,77.416,0,0,0-3.484-12.789,26.311,26.311,0,0,1,11.172.767A17.966,17.966,0,0,1,60.022,64.9ZM55.445,49.281c-.487-1.189-.947-2.235-1.576-3.524,6.632-2.708,9.637-6.561,10.016-7.073a17.852,17.852,0,0,1,4.05,11.174A41.909,41.909,0,0,0,55.445,49.281Z"
  })))));
}